<script setup lang="ts">
import TextButton from '@/components/base/TextButton.vue';
import SmallBodyText from '@/components/base/typography/SmallBodyText.vue';

withDefaults(
  defineProps<{
    changeLinkTarget: { step: string; stepVariant?: string };
    disabled: boolean;
    showCheckoutStepNumbers?: boolean;
    routeName?: string;
    showChangeLink: boolean;
    stepNumber: number;
  }>(),
  {
    routeName: 'Checkout',
  },
);

const stepNumberUtilities = [
  'bg-amber-300',
  'font-nutcase',
  'inline-block',
  'leading-3',
  'mr-2.5',
  'py-1',
  'rounded-full',
  'transform',
  '-translate-y-0.5',
  'text-center',
  'text-sm',
  'w-5',
].join(' ');
</script>

<template>
  <div class="flex justify-between">
    <h2
      class="mb-0 text-lg leading-5 text-left normal-case md:text-xl"
      :class="{ 'opacity-50': disabled }"
      :aria-disabled="disabled"
      :data-test="`checkout-header-step-${stepNumber}`"
    >
      <span
        v-if="showCheckoutStepNumbers"
        :class="stepNumberUtilities"
        data-test="checkout-step-number"
      >
        {{ stepNumber }}
      </span>
      <span>
        <slot />
      </span>
    </h2>
    <RouterLink
      v-if="showChangeLink && changeLinkTarget.step !== 'tray'"
      :to="{ name: routeName, params: changeLinkTarget }"
      class="text-xs underline color-inherit"
      :data-promo="(routeName === 'DigitalGiftBuild' && 1) || undefined"
      :data-promo-name="
        (routeName === 'DigitalGiftBuild' &&
          `GiftDrop - Step ${stepNumber} - Select Gift Option`) ||
        undefined
      "
      :data-promo-creative="(routeName === 'DigitalGiftBuild' && 'Change') || undefined"
      :data-test="`step-${stepNumber}-change-link`"
    >
      <TextButton>
        <SmallBodyText class="font-extralight">Edit</SmallBodyText>
      </TextButton>
    </RouterLink>
  </div>
</template>
